var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8564 8L14 0L0.143616 8V24L14 32L27.8564 24V8ZM8.50002 13.5C7.11931 13.5 6.00002 14.6193 6.00002 16C6.00002 17.3807 7.11931 18.5 8.50002 18.5H19.5C20.8807 18.5 22 17.3807 22 16C22 14.6193 20.8807 13.5 19.5 13.5H8.50002Z",
    fill: "#DFF8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveIcon);
export default __webpack_public_path__ + "static/media/inactive-icon.def0487e42a66fb60af3b81699c6920a.svg";
export { ForwardRef as ReactComponent };